import "../styles/_loader.scss";

const Loader = () => {
    return (
        <div className="loader">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    )
};

export default Loader;
